// extracted by mini-css-extract-plugin
export default {"noquotes":"NoQuotesFound_noquotes__yuJ28"};